import {
  Approval,
  ApprovalGroup,
} from "../../../core/models/entities/Approval";
import { ApprovalDto, ApprovalGroupDto } from "../responses/ApprovalDto";

export function mapToApprovalGroup(dto: ApprovalGroupDto): ApprovalGroup {
  const result = {
    customer: dto.customer ? mapToApproval(dto.customer) : null,
    vendor: dto.vendor ? mapToApproval(dto.vendor) : null,
    external: dto.external ? mapToApproval(dto.external) : null,
    externalEmail: dto.externalEmail,
    publicKey: dto.publicKey,
  };
  return result;
}

export function mapToApproval(dto: ApprovalDto): Approval {
  return {
    approver: dto.approver,
    status: dto.status,
    approvedAtUtc: new Date(dto.approvedAtUtc),
    rejectionNote: dto.rejectionNote,
  };
}
